const forgeRockCodes = {
  TIMEOUT: '110',
  SUCCESS: 'AM_0000',
  INVALID_CREDENTIAL: 'AM_0001',
  EXPIRED: 'AM_0002',
  ACCOUNT_BLOCKED: 'AM_0003',
  TEMPORARY_PASSWORD: 'AM_0004',
  MAX_RETRY_REACHED: 'AM_0007',
  NOT_ADVISEUR_ACCOUNT: 'AM_0008',
  DIGITAL_PASSPORT_ACTIVE: 'AM_0009',
  ALREADY_COUPLED: 'AM_1001',
  NOT_FOUND: 'AM_1002',
  OTHERS: 'AM_9999',
};

const errorMessages = {
  'AM_9999': 'General exception',
  'AM_0001': 'Invalid Exception',
  'AM_0002': 'Uw account is niet meer geldig, Neem contact op met uw toegangsbeheerder om uw account te laten deblokkeren. Bent u zelf de beheerder? Neem dan contact op met onze afdeling Digital Support via tel: 070-513-03-20 of e-mail digitalsupport@nn.nl',
  'AM_0003': 'UW account is geblokkeerd. Neem contact op met uw toegangsbeheerder om uw account te laten deblokkeren. Bent u zelf de beheerder? Neem dan contact op met onze afdeling Digital Support via tel: 070-513-03-20 of e-mail digitalsupport@nn.nl',
  'AM_0004': 'Account has a temporary password',
  'AM_0007': 'Max Retry Reached',
  'AM_0008': 'Not an Advisor Account',
  'AM_0009': 'Digital Passport Active',
  'AM_1001': 'Connecting of account not allowed by Backend',
  'AM_1002': 'Account not found in backend',
  'DEFAULT_ERROR_MESSAGE': 'Er is iets mis gegaan. Probeer het later nog eens.',
};

export {
  forgeRockCodes,
  errorMessages,
};
